import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { colors, fontSize } from "style";
import { RATINGS } from "constants/index";
import Image from "components/Image";

/**
 * RatingButtons
 *
 * @param {String}   name
 * @param {String}   label
 * @param {Function} onChange
 * @param {String}   thumbsUpIcon
 * @param {String}   thumbsDownIcon
 * @param {Boolean}  disabled
 * @param {Boolean}  positionRight
 */
const RatingButtons = ({ name, label, onChange, thumbsUpIcon, thumbsDownIcon, disabled, positionRight, ...props }) => {
  const handleClick = (rating) => {
    if (disabled) return;

    onChange(name, rating);
  };

  return (
    <div css={styles.rating(positionRight)} {...props}>
      {label}
      <button
        css={styles.thumbButton}
        aria-label="Thumbs up"
        onClick={() => handleClick(RATINGS.positive)}
        disabled={disabled}
      >
        <Image url={thumbsUpIcon} css={styles.thumbUpDown} />
      </button>
      <button
        css={styles.thumbButton}
        aria-label="Thumbs down"
        onClick={() => handleClick(RATINGS.negative)}
        disabled={disabled}
      >
        <Image url={thumbsDownIcon} css={styles.thumbUpDown} />
      </button>
    </div>
  );
};

const styles = {
  rating: (positionRight = false) => css`
    display: inline-flex;
    align-items: center;
    gap: 1rem;
    font-size: ${fontSize.small};
    font-weight: 500;
    line-height: 1.2;
    border-radius: 4px;
    color: ${colors.grayAnatomyBase2};
    ${positionRight && `margin-left: auto;`}
  `,
  thumbButton: css`
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover:enabled {
      transform: scale(1.2);
    }
    &:focus {
      outline: none;
    }
    &:disabled {
      cursor: default;
      opacity: 0.5;
    }
  `,
  thumbUpDown: css`
    width: 2rem;
    height: 2rem;
  `,
};

RatingButtons.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  thumbsUpIcon: PropTypes.string.isRequired,
  thumbsDownIcon: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  positionRight: PropTypes.bool,
};

export default RatingButtons;
